import React, { useState } from 'react';
import { useTranslate } from '@bynder/localization';
import { notify } from '@bynder/design-system';
import ComponentService, { PartialComponent } from 'packages/services/ComponentService';
import ComponentOverview from './ComponentOverview';
import useComponents from '../useComponents';
import useEditor from '~/hooks/useEditor';

interface UseComponentOverviewProps {
    onApplySuccess: () => void;
}

const useComponentOverview = ({ onApplySuccess }: UseComponentOverviewProps) => {
    const { translate } = useTranslate();
    const [isOpen, setOpen] = useState(false);
    const { creativeType } = useEditor();

    const { applyComponent } = useComponents();

    const isImageDesign = creativeType === 'IMAGE';

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const handleOnApply = async (component: PartialComponent, isUniqueContentProperties: boolean) => {
        const response = await ComponentService.getComponentById(component.id.toString());

        if (response.status !== 200) {
            notify({
                title: translate('components.create.modal.getComponent.error.badRequest'),
                variant: 'error',
            });

            return;
        }

        applyComponent(response.json, isUniqueContentProperties);
        onApplySuccess();
        setOpen(false);
    };

    const renderComponentOverview = () => {
        return (
            <ComponentOverview
                isOpen={isOpen}
                onClose={onClose}
                onApply={handleOnApply}
                isImageDesign={isImageDesign}
            />
        );
    };

    return {
        toggleComponentOverview: isOpen ? onClose : onOpen,
        renderComponentOverview,
    };
};

export default useComponentOverview;
